import jss from 'jss';

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 5px'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '15px 5px',
    '& > *': {
      marginRight: 5
    }
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();



// WEBPACK FOOTER //
// ./src/views/pending-product-instance/styles/provision-table.js